
import type { BlockRendererProps } from '@/lib/email-builder/block-registry';
import { parseBlockConfiguration } from '@/types/email-blocks';
import type { ImageBlockConfiguration } from '@/types/block-configurations';

export function ImageBlock({ block, isSelected, isHovered, onSelect, onHover }: BlockRendererProps) {
  const config = parseBlockConfiguration(block) as ImageBlockConfiguration;

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        onSelect(block.id);
      }}
      onMouseEnter={(e) => {
        e.stopPropagation();
        onHover(block.id);
      }}
      onMouseLeave={() => onHover(null)}
      className={`
        lw-block-image cursor-pointer rounded transition-all
        ${isSelected ? 'ring-2 ring-primary ring-offset-2' : ''}
        ${isHovered && !isSelected ? 'ring-1 ring-muted-foreground/50' : ''}
      `}
      style={{
        textAlign: config.alignment?.horizontal || 'center',
        paddingTop: `${config.padding?.top ?? 0}px`,
        paddingRight: `${config.padding?.right ?? 0}px`,
        paddingBottom: `${config.padding?.bottom ?? 10}px`,
        paddingLeft: `${config.padding?.left ?? 0}px`,
      }}
    >
      {config.src ? (
        <img
          src={config.src}
          alt={config.alt || 'Image'}
          title={config.title}
          style={{
            width: config.width ? `${config.width}px` : 'auto',
            height: config.height ? `${config.height}px` : 'auto',
            maxWidth: '100%',
            display: 'inline-block',
            borderWidth: config.border?.width ? `${config.border.width}px` : '0',
            borderStyle: config.border?.style || 'solid',
            borderColor: config.border?.color || '#000000',
            borderRadius: config.border?.radius ? `${config.border.radius}px` : '0',
          }}
        />
      ) : (
        <div 
          className="lw-block-image-placeholder bg-muted flex items-center justify-center text-muted-foreground"
          style={{
            width: config.width ? `${config.width}px` : '200px',
            height: config.height ? `${config.height}px` : '150px',
            maxWidth: '100%',
            display: 'inline-block',
          }}
        >
          <span>Choose an image in the properties panel</span>
        </div>
      )}
    </div>
  );
}
